import { Button, Card, Space, Upload, Col, Row, Progress, message, Checkbox, Modal, Input, Spin } from "antd";
import { FileWordOutlined, FileExcelOutlined, FilePptOutlined,  FilePdfOutlined } from '@ant-design/icons';
import React from "react";
import axios from "axios";
import md5 from "md5";
import { config } from './config'
import { getBaseUrl } from './utils/utils'
import dark_icon_open_26 from "./img/dark_open_26.svg";

// import dark_icon_word_26 from "./img/dark_file_word_26.svg";
// import dark_icon_excel_26 from "./img/dark_file_excel_26.svg";
// import dark_icon_ppt_26 from "./img/dark_file_ppt_26.svg";

import icon_word_32 from "./img/file_word_32.svg";
import icon_excel_32 from "./img/file_excel_32.svg";
import icon_ppt_32 from "./img/file_ppt_32.svg";
import icon_pdf_32 from "./img/file_pdf_32.svg";

import dark_icon_save_26 from "./img/dark_save_26.svg";

const { Meta } = Card;
const { TextArea } = Input;
const commonToken = config.downloadCommonToken;
const downloadKey = config.downloadKey;

const baseUrl = getBaseUrl(true);
class Uploader extends React.Component {
  constructor(props) {
    super(props);
    //初始化state
    this.state = {
      pheecwsUrl: '',
      platformUrl: '',
      upload: true,
      filename: null,
      convert: false,
      download: false,
      convertedFilename: null,
      convertType: window.document.libIsLinux? 210: 200,
      docidUpload: null,
      taskid: null,
      percentage: 0,
      docidDownload: null,
      downloadLoading: false,
      AITableChecked: true,
      isStopConvertProcessTimmerId: false,
      convertloadLoading: false,
      showReportJiraDialog: false,
      reportJiraTitle: '',
      reportJiraDescription: '',
      reportJiraKey: null,
      reportJiraTaskId: null,
      reportJiraTaskLoading: false,
      clickedCard: 'pdf_0_0',
      uploadAccept: 'application/pdf',
      uploadIcon: icon_pdf_32,
      pdfToOfficeVersion: 'Loading...',
      officeToPdfVersion: '',
      pdfToOfficeLinuxVersion: '',
      isHideOfficeToPdfBlock: baseUrl.includes('beta'),
      loading: false
    };
    this.onConvert = this.onConvert.bind(this);
    this.convertProcess = this.convertProcess.bind(this);
    this.onDownload = this.onDownload.bind(this);
  }

  componentDidMount() {
    this.loadServerConfig();
    message.config({maxCount: 1});
  }

  loadServerConfig = () => {
    const pheecwsUrl = this.getPheeCwsBaseUrl();
    let url = pheecwsUrl + '/cpdfapi/v1/pdf-converter/server-config?v=' + new Date().valueOf();
    this.setState({loading: true});
    axios.get(url).then((res) => {
      const result = res.data;
      console.log('TCL: BaseUrlManage -> getServerConfig -> response', result);
      const { data, ret } = result;
      if (ret !== 0) {
        message.error('The service is currently unavailable. Please try again later.');
      }
      const params = {};
      
      params['pheecwsUrl'] = pheecwsUrl;
      params['platformUrl'] = data.platformApiUrl + '/platform';
      data.pdfToOfficeVersion && (params['pdfToOfficeVersion'] = data.pdfToOfficeVersion);
      data.officeToPdfVersion && (params['officeToPdfVersion'] = data.officeToPdfVersion);
      data.pdfToOfficeLinuxVersion && (params['pdfToOfficeLinuxVersion'] = data.pdfToOfficeLinuxVersion);
      params['loading'] = false;
      this.setState(params);
    }).catch((err) => {
      console.log('TCL: getServerConfig -> err', err);
      message.error('The service is currently unavailable. Please try again later.');
      const params = {};
      params['pheecwsUrl'] = pheecwsUrl;
      params['platformUrl'] = config.pheePlatformUrl + '/platform';
      params['pdfToOfficeVersion'] = config.pdfToOfficeVersion;
      params['officeToPdfVersion'] = config.officeToPdfVersion;
      params['pdfToOfficeLinuxVersion'] = config.pdfToOfficeLinuxVersion;
      params['loading'] = false;
      this.setState(params);
    });
  };

  getPheeCwsBaseUrl() {
    const pheecwsUrls = config.pheecwsUrls;
    let url = 'https://pheecws-docker.connectedpdf.com';
    if(baseUrl.includes('beta')) {
      url = pheecwsUrls.prod;
    } else if (baseUrl.includes('azk8s')) {
      url = pheecwsUrls.azk8s;
    }
    return url;
  };

  onConvert() {
    this.setState({ convertloadLoading: true});
    const { AITableChecked, convertType, platformUrl } = this.state;
    if(!platformUrl) {
      console.log('platformUrl:', platformUrl);
      return;
    }
    let data;
    data = { documents: [{ docid: this.state.docidUpload }] };
    if(AITableChecked === true && [200, 210, 201, 211, 202, 212].indexOf(convertType) !== -1) {//pdf to office
      data['confText'] = '{"bUseAIRecognize": true}';
    }
    console.log(data);
    
    let url = `${platformUrl}/api/doc/convert?access_token=${commonToken}&type=${this.state.convertType}`;

    axios
      .post(url, data)
      .then((response) => {
        this.setState({ taskid: response.data.data.taskid });
        console.log(this.state.taskid);
        if(typeof(this.state.taskid) != 'undefined' && this.state.taskid) {
          this.convertProcess(this.state.taskid);
        } else {
          message.error('ret:' + response.data.ret + 'msg:' + response.data.msg)
        }
        this.setState({
          convertloadLoading: false,
        });
      })
      .catch(function (error) {
        console.log(error);
        this.setState({
          convertloadLoading: false,
        });
      });

    let c = /(.*)\.\w+/;
    let last =
      [200, 210].indexOf(convertType) !== -1
        ? ".docx"
        : [201, 211].indexOf(convertType) !== -1
        ? ".xlsx"
        : [202, 212].indexOf(convertType) !== -1
        ? ".pptx" 
        : ".pdf";
    this.setState({
      percentage: 0,
      isStopConvertProcessTimmerId: false,
      convertedFilename: c.exec(this.state.filename)[1] + last,
    });
  }

  convertProcess(taskid) {
    const { isStopConvertProcessTimmerId, platformUrl } = this.state;
    if(isStopConvertProcessTimmerId === true) {
      return;
    }
    let url = `${platformUrl}/api/task?access_token=${commonToken}&taskid=${taskid}`;
    // console.log(url);

    axios.get(url).then((response) => {
      // console.log(response.data);
      console.log(response.data.data.percentage);
      if(response.data.ret !== 0 && response.data.ret !== 1) {
        message.error('ret:' + response.data.ret + 'msg:' + response.data.msg)
        return;
      }
      this.setState({ percentage: response.data.data.percentage });
      //如果转换未完成，每半秒重测一次
      if (response.data.data.percentage !== 100) {
        setTimeout(() => {
          this.convertProcess(taskid);
        }, 500);
      } else {
        this.setState({ 
          docidDownload: response.data.data.docid, 
          reportJiraTaskId: null, 
          reportJiraKey: null,
          reportJiraTitle: '',
          reportJiraDescription: '',
          reportJiraTaskLoading: false,
        });
        console.log(this.state.docidDownload);
      }
    });
  }

  onDownload() {
    //将下载按钮变为loading状态，防止用户连续摁多次
    this.setState({
      downloadLoading: true,
    });
    let sign = md5(
      commonToken + this.state.docidDownload + downloadKey
    ).toString();
    console.log(sign);

    let url = `${this.state.platformUrl}/api/download?access_token=${commonToken}&docid=${this.state.docidDownload}&sign=${sign}`;

    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        console.log(response);

        //直接点击链接就能下载文件
        const aLink = document.createElement("a");
        aLink.href = url;
        aLink.click();
      })
      .then(() => {
        //在获得回应后等待3秒钟再恢复下载按钮
        setTimeout(() => {
          this.setState({
            downloadLoading: false,
          });
        }, 3000);
      });
  }

  onChangeAITable = (e) => {
    this.setState({AITableChecked: e.target.checked});
  }

  onRemoveIcon = () => {
    this.setState({
      isStopConvertProcessTimmerId: true,
      percentage: 0,
    });
  }

  onClickReportJira = (/**e**/) => {
    const { docidUpload } = this.state;
    if(!docidUpload) {
      message.error('Please upload your document for conversion.');
      return;
    }
    this.setState({showReportJiraDialog: true});
  }

  handleReportJiraOk = (e) => {
    const { reportJiraTitle, reportJiraDescription, docidUpload, docidDownload, filename, convertedFilename, convertType } = this.state;
    if( !reportJiraTitle ) {
      message.error('Please input title.');
      return;
    }
    if( !reportJiraDescription ) {
      message.error('Please input description.');
      return;
    }
    if( !docidUpload ) {
      message.error('Please upload your document for conversion.');
      return;
    }
    this.setState({reportJiraTaskLoading: true});
    const beforeConvertSign = md5(commonToken + docidUpload + downloadKey).toString();
    const beforeConvertFileUrl = `${this.state.platformUrl}/api/download?access_token=${commonToken}&docid=${docidUpload}&sign=${beforeConvertSign}`;
    const data = {
      summary: reportJiraTitle,
      description: reportJiraDescription,
      beforeConvertFileUrl: beforeConvertFileUrl,
      beforeConvertFileName: filename,
      convertType: convertType,
    };

    if (docidDownload) {
      const afterConvertSign = md5(commonToken + docidDownload + downloadKey).toString();
      const afterConvertFileUrl = `${this.state.platformUrl}/api/download?access_token=${commonToken}&docid=${docidDownload}&sign=${afterConvertSign}`;
      data['afterConvertFileUrl'] = afterConvertFileUrl;
      data['afterConvertFileName'] = convertedFilename;
    }

    console.log(data);
    
    let url = `${this.state.pheecwsUrl}/cpdfapi/v1/jira/issue?`;

    axios
      .post(url, data)
      .then((response) => {
        console.log('response:', response);
        const { data } = response;
        if(data.ret !== 0) {
          message.error('Creation failed, please try again later');
          this.setState({showReportJiraDialog: false, reportJiraTaskLoading: false});
        } else {
          const taskId = data.data.taskId;
          this.setState({reportJiraTaskId: taskId}, () => {
            message.success('The task has been submitted successfully, please wait');
            setTimeout(() => {
              this.getReportJiraTask(taskId);
            }, 3000);
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        message.error('Creation failed, please try again later');
        this.setState({showReportJiraDialog: false, reportJiraTaskLoading: false});
      });
  }

  getReportJiraTask = (taskId) => {
    let url = `${this.state.pheecwsUrl}/cpdfapi/v1/jira/task?taskId=${taskId}`;
    axios.get(url).then((response) => {
      console.log(response);
      const { data } = response;
      if(data.ret !== 0) {
        message.error('Creation failed, please try again later');
        this.setState({reportJiraTaskLoading: false});
        return;
      }
      const { status, jiraKey } = data.data;
      if(status === 3) { //失败
        message.error('Creation failed, please try again later');
        this.setState({reportJiraTaskLoading: false});
      } else if(status === 2) { //成功
        message.success('Creation success');
        this.setState({reportJiraTaskLoading: false, reportJiraKey: jiraKey});
      } else {// 处理中
        setTimeout(() => {
          this.getReportJiraTask(taskId);
        }, 3000);
        return;
      }
    });
  }
  
  handleReportJiraCancel = () => {
    this.setState({showReportJiraDialog: false});
  }

  getPdfToOfficeList() {
    return [
      [
        {title: "PDF To Word", description: "Convert PDF to Word documents", convertType: window.document.libIsLinux? 210: 200},
        {title: "PDF To Excel", description: "Convert PDF to Excel documents", convertType: window.document.libIsLinux? 211: 201},
        {title: "PDF To PowerPoint", description: "Convert PDF to PowerPoint", convertType: window.document.libIsLinux? 212: 202},
      ]
    ];
  }

  getOfficeToPdfList() {
    return [
      [
        {title: "Word To PDF", description: "Convert Word to PDF documents", convertType: 205},
        {title: "Excel To PDF", description: "Convert Excel to PDF documents", convertType: 206},
        {title: "PowerPoint To PDF", description: "Convert PowerPoint to PDF", convertType: 207},
      ]
    ];
  }

  getReportJiraModal = () => {
    const { showReportJiraDialog, reportJiraTitle, reportJiraDescription, reportJiraKey, reportJiraTaskLoading } = this.state;
    const btnDisabled = !reportJiraTitle || !reportJiraDescription;
    const footer = [
      <Button key="cancel" onClick={this.handleReportJiraCancel}>Cancel</Button>
    ];
    if(!reportJiraKey) {
      footer.push(
        <Button 
        key="submit" 
        type="primary" 
        onClick={this.handleReportJiraOk} 
        loading={reportJiraTaskLoading}
        disabled={btnDisabled} >
          Create
        </Button>
      );
    }
    return (
      <Modal wrapClassName={`report-jira-modal`} title="Report to Jira" visible={showReportJiraDialog} onCancel={this.handleReportJiraCancel} footer={footer}>
        { reportJiraKey && 
          <div className="report-jira-success">
            <span>It has been reported to JIRA，ID：{reportJiraKey}</span>
          </div> 
        }
        { !reportJiraKey && 
          <form className="report-jira-form">
            <div className="report-jira-tip">
              <span>By clicking the "Create" button, you agree to submit the information you have provided here to our JIRA system, including the uploaded sample files.</span>
            </div>
            <div className="form-item required">
              <div className="item-title">
                Title
              </div>
              <div className="item-input">
                <Input value={reportJiraTitle} onChange={(e) => {this.setState({reportJiraTitle: e.target.value})}}/>
              </div>
            </div>

            <div className="form-item required">
              <div className="item-title">
                Description
              </div>
              <div className="item-input">
                <TextArea value={reportJiraDescription} onChange={(e) => {this.setState({reportJiraDescription: e.target.value})}}/>
              </div>
            </div>
          </form>
        }
      </Modal>
    );
  }

  getPdfToOfficeBlock = () => {
    const { clickedCard, AITableChecked, pdfToOfficeVersion, pdfToOfficeLinuxVersion } = this.state;
    const convertList = this.getPdfToOfficeList();
    const libVersion = window.document.libIsLinux ? pdfToOfficeLinuxVersion : pdfToOfficeVersion;
    return (
      <>
        <div className="convert-header">
          <div className="title">
            <span>PDF To Office</span>
          </div>
          <div className="below">
            <div className="version-block">
              <span className="header-version">{libVersion}</span>
            </div>
            {!window.document.libIsLinux && 
              <div className="ai-block">
                <div key={999} className="ai-table-checked-box" style={{display: 'inline-block'}}>
                  <Checkbox checked={AITableChecked} disabled={clickedCard.includes('office_')} onChange={this.onChangeAITable}>Use AI to recognize borderless tables</Checkbox>
                </div>
              </div>
            }
          </div>
        </div>
       
        {
          // 需要包一层div，否则会出现警告 Encountered two children with the same key, `ant-space-item-0`.
          convertList.length > 0 &&
          <div>
            {
              convertList.map((row, rIndex)=>{
                return <Row key={rIndex} gutter={16}>
                  {row.map((col, cIndex) => {
                    let cardClassName = '';
                    let currentCard = 'pdf_' + rIndex + '_' + cIndex;
                    if(clickedCard === currentCard) {
                      cardClassName = 'clicked';
                    }
                    return <Col key={cIndex} span={8}>
                      <Card
                        className={cardClassName}
                        style={{backgroud: 'red'}}
                        size="small"
                        hoverable
                        onClick={() => {
                          const { convertType } = this.state;
                          let reportJiraKey= '';
                          let reportJiraTitle= '';
                          let reportJiraDescription= '';
                          if(convertType === col.convertType) {
                            reportJiraKey = this.state.reportJiraKey;
                            reportJiraTitle = this.state.reportJiraTitle;
                            reportJiraDescription = this.state.reportJiraDescription;
                          }
                          const params = {
                            convertType: col.convertType,
                            taskid: null,
                            percentage: 0,
                            docidDownload: null,
                            clickedCard: currentCard,
                            isStopConvertProcessTimmerId: true,
                            uploadAccept: 'application/pdf',
                            uploadIcon: icon_pdf_32,
                            reportJiraKey: reportJiraKey,
                            reportJiraTitle: reportJiraTitle,
                            reportJiraDescription: reportJiraDescription,
                          };
                          if([200, 210, 201, 211, 202, 212].indexOf(convertType) === -1) {//不为pdf to office
                            params.upload = true;
                            params.convert = false;
                            params.docidUpload = '';
                          }
                          this.setState(params);
                        }}
                      >
                        <Meta
                          title={col.title}
                          description={col.description}
                        />
                      </Card>
                    </Col>
                  })}
                </Row>
              })
            }
          </div>
        }
      </>
    );
  }

  

  getOfficeToPdfBlock = () => {
    const { clickedCard, officeToPdfVersion, isHideOfficeToPdfBlock } = this.state;
    if (isHideOfficeToPdfBlock === true || window.document.libIsLinux) {
      return '';
    }
    const convertList = this.getOfficeToPdfList();
    return (
      <>
        <div className="convert-header">
          <div className="title">
            <span>Office To PDF</span>
          </div>
          <div className="below">
            <div className="version-block">
              <span className="header-version">{officeToPdfVersion}</span>  
            </div>
          </div>
        </div>
        {
          // 需要包一层div，否则会出现警告 Encountered two children with the same key, `ant-space-item-0`.
          convertList.length > 0 &&
          <div>
            {
              convertList.map((row, rIndex)=>{
                return <Row key={rIndex} gutter={16}>
                  {row.map((col, cIndex) => {
                    let cardClassName = '';
                    let currentCard = 'office_' + rIndex + '_' + cIndex;
                    if(clickedCard === currentCard) {
                      cardClassName = 'clicked';
                    }
                    return <Col key={cIndex} span={8}>
                      <Card
                        className={cardClassName}
                        style={{backgroud: 'red'}}
                        size="small"
                        hoverable
                        onClick={() => {
                          const { convertType } = this.state;
                          let reportJiraKey= '';
                          let reportJiraTitle= '';
                          let reportJiraDescription= '';
                          if(convertType === col.convertType) {
                            reportJiraKey = this.state.reportJiraKey;
                            reportJiraTitle = this.state.reportJiraTitle;
                            reportJiraDescription = this.state.reportJiraDescription;
                          }
                          let uploadAccept = '', uploadIcon = icon_pdf_32;
                          if( [205].indexOf(col.convertType) !== -1 ) {
                            uploadAccept = '.docx';
                            uploadIcon = icon_word_32;
                          } else if ( [206].indexOf(col.convertType) !== -1 ) {
                            uploadAccept = '.xlsx';
                            uploadIcon = icon_excel_32;
                          } else if ( [207].indexOf(col.convertType) !== -1 ) {
                            uploadAccept = '.pptx';
                            uploadIcon = icon_ppt_32;
                          }
                          const params = {
                            convertType: col.convertType,
                            taskid: null,
                            percentage: 0,
                            docidDownload: null,
                            clickedCard: currentCard,
                            isStopConvertProcessTimmerId: true,
                            uploadAccept: uploadAccept,
                            uploadIcon: uploadIcon,
                            reportJiraKey: reportJiraKey,
                            reportJiraTitle: reportJiraTitle,
                            reportJiraDescription: reportJiraDescription,
                          };
                          if(convertType !== col.convertType) {
                            params.upload = true;
                            params.convert = false;
                            params.docidUpload = '';
                          }
                          this.setState(params);
                        }}
                      >
                        <Meta
                          title={col.title}
                          description={col.description}
                        />
                      </Card>
                    </Col>
                  })}
                </Row>
              })
            }
          </div>
        }
      </>
    );
  }
  render() {
    const { 
      convertType, 
      upload, 
      convert, 
      taskid, 
      convertloadLoading, 
      percentage, 
      convertedFilename, 
      downloadLoading,
      uploadAccept,
      uploadIcon,
      platformUrl,
      loading,
    } = this.state;
    return (
      <>
        {
          loading && <div className="loading"><Spin size={`large`}></Spin></div>
        }
        {this.getReportJiraModal()}
        <Space direction="vertical" size={12}>
          {this.getPdfToOfficeBlock()}
          {this.getOfficeToPdfBlock()}
          <Space direction="vertical" className="tools-main-content-content">
            <div key={uploadAccept}>
              <Upload
                accept={uploadAccept}
                listType="picture"
                iconRender={() => <img alt="pdf" src={uploadIcon} />}
                action={`${platformUrl}/api/doc?access_token=${commonToken}`}
                onChange={(info) => {
                  // console.log(info);
                  if (info.file.status === "done") {
                    console.log(info.file.response.data.docid);
                    console.log(info.file.name);
                    this.setState({
                      upload: false,
                      filename: info.file.name,
                      convert: true,
                      docidUpload: info.file.response.data.docid,
                    });
                  }
                  if (info.fileList.length === 0) {
                    this.setState({
                      upload: true,
                      convert: false,
                      docidUpload: null,
                      taskid: null,
                      docidDownload: null,
                      percentage: 0,
                      reportJiraKey: '',
                    });
                  }
                }}
                maxCount={1}
                progress={{
                  strokeColor: {
                    "0%": "#108ee9",
                    "100%": "#87d068",
                  },
                  strokeWidth: 5,
                  format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
                  className: 'upload-progress-customize'
                }}
                onRemove={this.onRemoveIcon}
              >
              {upload ? (
                <Button
                  size="large"
                  shape="round"
                  icon={<img src={dark_icon_open_26} alt="open" />}
                  type="primary"
                >
                  Upload
                </Button>
              ) : null}
            </Upload>
            </div>
            {convert && !taskid ? (
              <Button
                size="large"
                shape="round"
                type="primary"
                className="convert-btn"
                onClick={this.onConvert}
                loading={convertloadLoading}
                disabled={convertloadLoading}
              >
                {[200, 210].indexOf(convertType) !== -1 ? (
                  <>
                    {/* <img alt="word" src={dark_icon_word_26} /> */}
                    <FileWordOutlined />
                    <span>Convert to Word</span>
                  </>
                ) : [201, 211].indexOf(convertType) !== -1 ? (
                  <>
                    {/* <img alt="excel" src={dark_icon_excel_26} /> */}
                    <FileExcelOutlined />
                    <span>Convert to Excel</span>
                  </>
                ) : [202, 212].indexOf(convertType) !== -1 ? (
                  <>
                    {/* <img alt="excel" src={dark_icon_ppt_26} /> */}
                    <FilePptOutlined />
                    <span>Convert to PPT</span>
                  </>
                ) : (
                  <>
                  <FilePdfOutlined />
                  <span>Convert to PDF</span>
                  </>
                )}
              </Button>
            ) : null}
            {taskid ? (
              <>
                <Progress
                  percent={percentage}
                  strokeColor={{ "0%": "#108ee9", "100%": "#87d068" }}
                />
                {percentage === 100 ? (
                  <>
                    <div className="download-block">
                      <div className="download-file-icon">
                        {[200, 210].indexOf(convertType) !== -1 ? (
                          <img alt="word" src={icon_word_32} />
                        ) : [201, 211].indexOf(convertType) !== -1 ? (
                          <img alt="excel" src={icon_excel_32} />
                        ) : [202, 212].indexOf(convertType) !== -1 ? (
                          <img alt="ppt" src={icon_ppt_32} />
                        ) : (
                          <img alt="pdf" src={icon_pdf_32} />
                        )
                        }
                      </div>
                      <div className="download-file-content">
                        <span className="download-file-text">{convertedFilename}</span>
                      </div>
                    </div>
                    {/* 使用Upload展示会出现闪动问题 */}
                    {/* <Upload
                      iconRender={() =>
                        convertType === 11 ? (
                          <img alt="word" src={icon_word_32} />
                        ) : convertType === 14 ? (
                          <img alt="excel" src={icon_excel_32} />
                        ) : (
                          <img alt="ppt" src={icon_ppt_32} />
                        )
                      }
                      listType="picture"
                      fileList={[{ name: convertedFilename }]}
                      showUploadList={{ showRemoveIcon: false }}
                    /> */}
                  </>
                ) : null}
                {percentage === 100 ? (
                  <Button
                    size="large"
                    shape="round"
                    type="primary"
                    onClick={this.onDownload}
                    icon={<img alt="save" src={dark_icon_save_26} />}
                    loading={downloadLoading}
                  >
                    Download
                  </Button>
                ) : null}
              </>
            ) : null}
          </Space>
          <div className="report-jira-container">
            <Button className={`report-jira-btn`} onClick={this.onClickReportJira}>Report to Jira</Button>
          </div>
        </Space>
      </>
    );
  }
}

export default Uploader;
